<template>
  <div>
    <section class="legend-status-container">
      <div class="row legend-name">
        <div class="col-md-12 p-0 pb-2">
          <i class="fas fa-list-ul"></i>
          <label>Leyenda de Estatus</label>
        </div>
      </div>
      <div class="status-container row ml-1 mt-2">
        <div class="col-md-3 not-available">
          <i class="fas fa-circle"></i>
          <label>No Disponible</label>
          <br />
          <span>No está disponible para evaluación</span>
        </div>
        <div class="col-md-2 pending">
          <i class="fas fa-circle"></i>
          <label>Pendiente</label>
          <br />
          <span>De informe de progreso</span>
        </div>
        <div class="col-md-2 submit">
          <i class="fas fa-circle"></i>
          <label>Sometido</label>
          <br />
          <span>El informe de progreso</span>
        </div>
        <div class="col-md-2 discussed">
          <i class="fas fa-circle "></i>
          <label>Discutido</label>
          <br />
          <span>El informe fue discutido con los padres</span>
        </div>
        <div class="col-md-3 not-available">
          <i class="fas fa-circle "></i>
          <label>No Aplica (N/A)</label>
          <br />
          <span>No aplica para documentación de semana</span>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
export default {
  name: 'StatusLegend',
};
</script>

<style>
.legend-status-container {
  background-color: #f7f7f7;
  margin: 10px 0;
  padding: 15px 0;
  border-radius: 4px;
}
.legend-name {
  border-bottom: 1px solid #e2e2e2;
  margin-right: 15px;
  margin-left: 15px;
}
.legend-name label {
  color: #3f5b60;
  font-size: 14px;
}
.legend-name i {
  color: #ff7058;
}
.status-container div label {
  margin-right: 8px;
}
.status-container div span {
  font-weight: lighter;
  color: #727272;
  font-size: 12px;
}
.status-container div i {
  font-size: 10px;
}

label {
  margin: 0;
  font-weight: bold;
}
i {
  margin-right: 8px;
}
.not-available i {
  color: #b5c3bc;
}
.pending i {
  color: #fcc9c8;
}
.submit i {
  color: #fae76f;
}
.discussed i {
  color: #a3e5b3;
}
</style>
